<script>
    import {emitPageViewEvent} from '../actions/pageAnalytics'

    export let location
    emitPageViewEvent(location,'Privacy')
</script>
<style>

</style>

<div class="parent mt3 ">
    <div class="pageContent flex mx-auto">
        <div class="flex flex-column flex-auto">
            <h2 class='mt1'>Terms of Use</h2>
            <p>
                This site ("Site") is operated by David Han Software. Please read these terms of use, which include the
                Privacy Policy, ("Terms"). By accessing this Site or using the services offered on the Site, you
                indicate your agreement to these Terms. If you do not agree, please do not use this Site. We may modify
                these Terms (including the Privacy Policy) from time to time by displaying updated Terms on the Site.
                Your continued use of the Site, after the updated Terms are displayed, indicates your agreement to the
                modified Terms.
            </p>
            <h2 class='mt1'>Privacy Policy</h2>
            <p>
                Post A Note is committed to protecting your privacy. We treat data privacy very seriously. This Privacy
                Policy describes the information we collect through our Site, how we use it, and how you can make
                choices about use of that information. By using our Site you agree to this Privacy Policy.
                <br>
                Your data and information will be used in the following ways:
                <br><br>
                (1) We collect information to facilitate the basic functionality of, and to improve, our Site. This site
                uses Google Analytics. No personal or identifiable data, such as names or addresses, are shared to
                Google Analytics.
                <br><br>
                (2) We store names and addresses inputted to this Site securely in our databases in order to fulfill
                orders and shipments.
                We may share this data to our service providers (such as hosting, order fulfillment, and shipping
                providers) in order to fulfill orders and shipments.
                <br><br>
                (3) This Site uses cookies. You are not required to accept cookies from this Site. You can disable or
                delete the cookies by using your web browser's options.
                <br><br>
                (4) Our servers are located in the United States.
                <br><br>
                We may modify this Privacy Policy from time to time by displaying updated Terms on the Site. Your
                continued use of the Site after the updated Privacy Policy is displayed indicates your agreement to the
                modified Privacy Policy.
                <br><br>
                For questions or comments, please contact us at davjhan1@gmail.com
            </p>
        </div>
    </div>


</div>